import { defaultFetch } from './baseApi';
import { CompanyUserType } from './companiesApi';

export type StreamType = {
	id: number;
	name: string;
	streamId: number;
	startDate: string;
	endDate: string;
	tasks: StreamType[];
	responsibles: {
		name: string;
		users: CompanyUserType[];
	}[];
	owner: string | null;
	taskType: "wp"
};

export const getStreamsByProjectId = async (projectId: string) => {
	return defaultFetch<StreamType[]>(`/v0/projects/${projectId}/projectstreams`);
};

export type MilestoneType = {
	id: number;
	number: string;
	description: string | null;
	wp: string | null;
	completed: boolean;
	note: string | null;
	title: string;
	responsible: number;
	projectId: number;
	probativeDocumentation: string | null;
	forecastDate: string;
	effectiveDate: string | null;
	createdBy: number;
	updatedBy: number;
	wpStreamId: number;
	status: string;
	taskType: "milestone";
};

export const getMilestonesByProjectId = async (projectId: string) => {
	return defaultFetch<MilestoneType[]>(`/v0/projects/${projectId}/projectmilestones`);
};

export type DeliverableType = {
	id: number;
	number: string;
	description: string | null;
	wp: string | null;
	type: string;
	sent: boolean;
	approved: boolean;
	note: string | null;
	title: string;
	responsible: number;
	projectId: number;
	forecastDate: string;
	effectiveDate: string | null;
	createdBy: number;
	updatedBy: number;
	wpStreamId: number;
	status: string;
	taskType: "deliverable";
};

export const getDeliverablesByProjectId = async (projectId: string) => {
	return defaultFetch<DeliverableType[]>(`/v0/projects/${projectId}/projectdeliverables`);
};

export const getDeliverableByProjectIdAndDeliverableId = async (projectId: string, deliverableId: number) => {
	const url = `/v0/projects/${projectId}/projectdeliverables/${deliverableId}`;
	return defaultFetch<DeliverableType>(url);
};
export const getMilestoneByProjectIdAndMilestoneId = async (projectId: string, milestoneId: number) => {
	const url = `/v0/projects/${projectId}/projectmilestones/${milestoneId}`;
	return defaultFetch<MilestoneType>(url);
};

type WpType = {
	id: number;
	name: string;
	streamId: number;
	projectId: number;
	configurationType: string;
	startDate: string;
	endDate: string;
};
type ResponsibleType = {
	id: number;
	name: string;
	vat: string;
	address: string | null;
	pec: string | null;
	attorney: string | null;
	code: string;
	sizeCode: string | null;
	legalRepresentative: string | null;
	powerOfAttorney: number;
	payrollMgmtModule: false;
	aiEnabled: true;
	createdBy: number;
	updatedBy: number;
	hasModulePartnership: true;
};
export type SubtaskType = {
	id: number;
	name: string;
	objective: string | null;
	responsibles: ResponsibleType[];
	participants: [];
	type: string | null;
	owner: string | null;
	status: string | null;
	startDate: string;
	endDate: null;
	projectStreamId: number;
	parentId: number;
	taskType: "subtask";
};

export type TaskType = {
	id: number;
	name: string;
	objective: string | null;
	responsibles: ResponsibleType[];
	participants: [];
	wp: WpType;
	type: null;
	owner: null;
	status: null;
	subtasks: SubtaskType[];
	startDate: string;
	endDate: string;
	projectStreamId: number;
	parentId: null;
	taskType: "task";
};

export const getTasksByProjectIdStreamId = async (projectId: string, streamId: string) => {
	return defaultFetch<TaskType[]>(`/v0/projects/${projectId}/projectstreams/${streamId}/tasks`);
};
